const fields = `revision links { pageKey enabled elUrl enUrl }`;

export const GET_CONSOLE_HELP_LINKS = `query GetConsoleHelpLinks {
  getConsoleHelpLinks { ${fields} }
}`;

export const UPDATE_CONSOLE_HELP_LINKS = `mutation UpdateConsoleHelpLinks($expectedRevision: Int!, $links: [ConsoleHelpLinkInput!]!) {
  updateConsoleHelpLinks(expectedRevision: $expectedRevision, links: $links) { ${fields} }
}`;
